import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { useLang } from '~/hooks/useLang';

interface NumericIndicatorProps {
  readonly data: readonly { readonly name: string; readonly total: number; readonly color?: string }[];
  readonly title: string;
  readonly color?: string;
}

export default function NumericIndicator({ data, title, color = '#1976d2' }: NumericIndicatorProps) {
  const { translate } = useLang();
  
  const defaultColors = ['#1976d2', '#dc004e', '#9c27b0', '#f57c00', '#388e3c', '#0288d1', '#d32f2f', '#7b1fa2'];
  
  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', height: 'fit-content' }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {translate(title)}
        </Typography>
        <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 2, sm: 4, md: 10 }}>
          {data.length > 0 ? (
            data.map((item, index) => (
              <Grid item xs={2} sm={2} md={2} key={index}>
                <Card
                  sx={{
                    borderLeft: `5px solid ${item.color || defaultColors[index % defaultColors.length]}`,
                    transition: '0.3s ease-in-out',
                    boxShadow: 'none',
                    width: '100%',
                    '&:hover': {
                      borderLeft: `50px solid ${item.color || defaultColors[index % defaultColors.length]}`,
                      transition: '0.3s ease-in-out',
                    },
                  }}
                >
                  <CardContent>
                    <Typography noWrap={true}>
                      {item.name.toUpperCase()}
                    </Typography>
                    <Typography variant="h2">
                      {item.total ?? 0}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography sx={{ padding: '16px' }}>
              {translate('No data available')}
            </Typography>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
